import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import axios from 'axios';
import io from 'socket.io-client';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.nurradyo.com';
const API_URL = `${BASE_URL}/api`;
const STREAM_URL = `${BASE_URL}/stream`;
const BESMELE_URL = '/besmele2.mp3';

// Önceden tanımlı sosyal medya iconları (renkli SVG)
const PREDEFINED_ICONS = [
  { id: 'youtube', name: 'YouTube', color: '#FF0000', svg: '<svg viewBox="0 0 24 24" fill="#FF0000"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>' },
  { id: 'instagram', name: 'Instagram', color: '#E4405F', svg: '<svg viewBox="0 0 24 24" fill="#E4405F"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>' },
  { id: 'facebook', name: 'Facebook', color: '#1877F2', svg: '<svg viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>' },
  { id: 'twitter', name: 'X (Twitter)', color: '#000000', svg: '<svg viewBox="0 0 24 24" fill="#000000"><path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/></svg>' },
  { id: 'tiktok', name: 'TikTok', color: '#000000', svg: '<svg viewBox="0 0 24 24" fill="#000000"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>' },
  { id: 'telegram', name: 'Telegram', color: '#26A5E4', svg: '<svg viewBox="0 0 24 24" fill="#26A5E4"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>' },
  { id: 'whatsapp', name: 'WhatsApp', color: '#25D366', svg: '<svg viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>' },
  { id: 'spotify', name: 'Spotify', color: '#1DB954', svg: '<svg viewBox="0 0 24 24" fill="#1DB954"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/></svg>' },
  { id: 'soundcloud', name: 'SoundCloud', color: '#FF5500', svg: '<svg viewBox="0 0 24 24" fill="#FF5500"><path d="M1.175 12.225c-.051 0-.094.046-.101.1l-.233 2.154.233 2.105c.007.058.05.098.101.098.05 0 .09-.04.099-.098l.255-2.105-.27-2.154c0-.057-.045-.1-.09-.1m-.899.828c-.06 0-.091.037-.104.094L0 14.479l.165 1.308c0 .055.045.094.09.094s.089-.045.104-.104l.21-1.319-.21-1.334c0-.061-.044-.09-.09-.09m1.83-1.229c-.061 0-.12.045-.12.104l-.21 2.563.225 2.458c0 .06.045.12.119.12.061 0 .105-.061.121-.12l.254-2.474-.254-2.548c-.016-.06-.061-.12-.121-.12m.945-.089c-.075 0-.135.06-.15.135l-.193 2.64.21 2.544c.016.077.075.138.149.138.075 0 .135-.061.15-.15l.24-2.532-.24-2.623c0-.075-.06-.135-.135-.135m1.124.135c-.09 0-.149.075-.165.166l-.217 2.42.2 2.563c.016.09.09.166.18.166s.15-.09.164-.18l.24-2.548-.24-2.408c-.016-.09-.075-.165-.165-.165m.96-.405c-.105 0-.18.09-.195.18l-.172 2.64.187 2.563c.015.09.09.18.195.18.09 0 .18-.09.18-.18l.209-2.563-.209-2.64c-.015-.09-.09-.18-.18-.18m.99-.555c-.104 0-.194.09-.21.195L4.8 13.995l.165 2.548c.016.12.105.21.225.21.104 0 .18-.09.21-.21l.193-2.548-.21-2.641c-.015-.105-.09-.195-.21-.195m1.065-.21c-.12 0-.21.09-.225.21l-.15 2.851.15 2.548c.015.12.105.21.225.21.12 0 .21-.09.224-.21l.166-2.548-.165-2.851c-.016-.12-.105-.21-.226-.21m1.05-.39c-.12 0-.225.105-.238.225l-.15 3.24.15 2.52c.016.12.12.226.24.226.12 0 .224-.105.225-.226l.165-2.52-.165-3.24c0-.12-.105-.225-.225-.225m1.095-.315c-.135 0-.255.12-.255.255l-.15 3.556.165 2.519c0 .135.12.255.254.255.135 0 .24-.12.255-.27l.15-2.504-.15-3.556c-.015-.135-.12-.255-.255-.255m1.11-.12c-.15 0-.27.12-.285.255l-.12 3.66.135 2.504c0 .15.12.27.27.27.135 0 .255-.12.27-.27l.135-2.504-.135-3.645c-.015-.15-.135-.27-.285-.27m1.086.135c-.164 0-.284.135-.284.285l-.106 3.525.12 2.49c0 .149.12.284.27.284.165 0 .285-.12.285-.285l.135-2.489-.135-3.525c-.015-.15-.135-.285-.285-.285m1.17-.285c-.18 0-.314.15-.314.315l-.105 3.81.105 2.49c.015.165.135.315.314.315.165 0 .315-.15.315-.315l.12-2.49-.12-3.81c0-.165-.15-.315-.315-.315m1.095.54c-.18 0-.315.15-.33.33l-.075 3.255.09 2.474c.015.18.149.33.33.33.165 0 .315-.15.315-.33l.105-2.474-.105-3.255c0-.18-.15-.33-.315-.33m1.155-.66c-.195 0-.345.165-.36.345l-.075 3.57.09 2.46c.015.195.165.36.36.36.18 0 .33-.165.345-.36l.09-2.46-.09-3.57c-.015-.18-.165-.345-.36-.345m1.14.18c-.195 0-.36.165-.375.36l-.06 3.39.075 2.445c.015.195.18.36.375.36.18 0 .345-.165.36-.36l.09-2.445-.09-3.39c-.015-.195-.18-.36-.375-.36m1.155-.15c-.21 0-.375.165-.39.375l-.06 3.54.075 2.43c.015.21.18.375.39.375.195 0 .36-.165.375-.375l.09-2.43-.09-3.54c-.015-.21-.18-.375-.39-.375m1.14.24c-.21 0-.39.18-.39.39l-.045 3.3.06 2.415c0 .21.18.39.39.39.195 0 .375-.18.375-.39l.075-2.415-.075-3.3c0-.21-.165-.39-.375-.39m4.395-.315c-.225 0-.39.18-.405.39l-.045 3.615.06 2.4c.015.21.18.39.39.39.21 0 .375-.18.39-.39l.075-2.4-.06-3.615c-.015-.21-.18-.39-.405-.39m-3.24.09c-.21 0-.39.18-.39.39l-.06 3.525.06 2.4c.016.21.181.39.39.39.21 0 .375-.18.391-.39l.06-2.4-.06-3.525c0-.21-.18-.39-.39-.39m1.095.195c-.21 0-.39.18-.405.39l-.045 3.33.06 2.4c.015.21.18.39.39.39.21 0 .39-.18.405-.39l.06-2.4-.06-3.33c-.015-.21-.18-.39-.405-.39m1.095-.15c-.21 0-.405.18-.405.405l-.045 3.48.045 2.385c.016.21.195.39.405.39.21 0 .39-.18.405-.39l.06-2.385-.06-3.48c0-.225-.195-.405-.405-.405m1.845 1.11c-.48 0-.912.21-1.215.54-.12-1.29-.99-2.28-2.115-2.55-.24-.06-.48-.09-.735-.09-1.665 0-3.015 1.365-3.015 3.03v6.12c0 .18.135.33.3.345h6.78c1.335 0 2.415-1.08 2.415-2.415s-1.08-2.49-2.415-2.49"/></svg>' },
  { id: 'linkedin', name: 'LinkedIn', color: '#0A66C2', svg: '<svg viewBox="0 0 24 24" fill="#0A66C2"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>' },
  { id: 'pinterest', name: 'Pinterest', color: '#BD081C', svg: '<svg viewBox="0 0 24 24" fill="#BD081C"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/></svg>' },
  { id: 'discord', name: 'Discord', color: '#5865F2', svg: '<svg viewBox="0 0 24 24" fill="#5865F2"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"/></svg>' },
  { id: 'twitch', name: 'Twitch', color: '#9146FF', svg: '<svg viewBox="0 0 24 24" fill="#9146FF"><path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/></svg>' },
  { id: 'website', name: 'Web Sitesi', color: '#4285F4', svg: '<svg viewBox="0 0 24 24" fill="#4285F4"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/></svg>' },
  { id: 'email', name: 'E-posta', color: '#EA4335', svg: '<svg viewBox="0 0 24 24" fill="#EA4335"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>' },
  { id: 'other', name: 'Diger', color: '#666666', svg: '<svg viewBox="0 0 24 24" fill="#666666"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>' }
];

// Icon ID'den icon bilgisini al
const getIconById = (iconId) => {
  return PREDEFINED_ICONS.find(icon => icon.id === iconId) || PREDEFINED_ICONS.find(icon => icon.id === 'other');
};

// Google Play logosu (bağlantıda özel ikon yoksa kullanılır)
const PLAY_STORE_SVG = '<svg viewBox="0 0 24 24"><path fill="#00D7FE" d="M3.6 1.8c-.3.3-.4.8-.4 1.4v17.6c0 .6.1 1.1.4 1.4l.1.1 9.9-9.9v-.2L3.7 1.7z"/><path fill="#FFCE00" d="M16.9 15.7l-3.3-3.3v-.2l3.3-3.3.1.1 3.9 2.2c1.1.6 1.1 1.7 0 2.3l-3.9 2.2z"/><path fill="#FF3A44" d="M17 15.6l-3.4-3.4L3.6 22.2c.4.4 1 .4 1.7.1L17 15.6"/><path fill="#00F076" d="M17 8.8L5.3 2.1c-.7-.4-1.3-.3-1.7.1l10 10L17 8.8z"/></svg>';

// Menünün üstünde öne çıkarılacak bağlantılar: Play Store ve YouTube
const getFeaturedType = (link) => {
  const url = (link.url || '').toLowerCase();
  if (url.includes('play.google.com')) return 'playstore';
  if (link.iconId === 'youtube' || url.includes('youtube.com') || url.includes('youtu.be')) return 'youtube';
  return null;
};

// iOS tespit
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

function Listener() {
  const [radioState, setRadioState] = useState({});
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1);
  const [prevVolume, setPrevVolume] = useState(1);
  // Başlangıçta 77 çubuk minimum yükseklikte (5%)
  const [waveformBars, setWaveformBars] = useState(Array(77).fill(5));
  const [isStreamPlaying, setIsStreamPlaying] = useState(false);
  const [links, setLinks] = useState([]);
  const [readers, setReaders] = useState([]);
  const [aboutText, setAboutText] = useState('');
  const [showLinksModal, setShowLinksModal] = useState(false);
  const [modalView, setModalView] = useState('main'); // 'main', 'readers' veya 'about'
  const [slides, setSlides] = useState([]);
  const [shuffledSlides, setShuffledSlides] = useState([]); // Karıştırılmış slaytlar
  const [showSlideshow, setShowSlideshow] = useState(false);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [slideTransition, setSlideTransition] = useState(false); // Geçiş animasyonu için
  const [preloadedImages, setPreloadedImages] = useState({}); // Önbelleğe alınan resimler
  // Uyku zamanlayıcısı
  const [sleepEndAt, setSleepEndAt] = useState(null); // Bitiş zamanı (ms timestamp)
  const [sleepRemaining, setSleepRemaining] = useState(0); // Kalan süre (saniye)
  const [showCustomTimer, setShowCustomTimer] = useState(false);
  const [customTotalMinutes, setCustomTotalMinutes] = useState(60);
  const sleepStopRef = useRef(null);
// Seed'li rastgele sayı üreteci
const seededRandom = (seed) => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

const getListenerCount = () => {
  const seed = Math.floor(Date.now() / 120000); // 2 dakikalık pencere
  const base = Math.floor(seededRandom(seed) * 11) + 23; // 33-43
  const direction = seededRandom(seed + 99) > 0.5 ? 1 : -1; // ±1
  const next = base + direction;
  return Math.max(33, Math.min(43, next));
};

const [fakeListeners, setFakeListeners] = useState(getListenerCount);  const slideshowIntervalRef = useRef(null);
  const preloadTimeoutRef = useRef(null);
  const wakeLockRef = useRef(null); // Ekran kararmasını önlemek için
  const besmeleReadyRef = useRef(false);
  const streamPreloadedRef = useRef(false);

  const audioRef = useRef(null);
  const besmeleRef = useRef(null);
  const socketRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const sourceRef = useRef(null);
  const besmeleSourceRef = useRef(null);
  const mixerRef = useRef(null);
  const animationRef = useRef(null);
  const waveformHistoryRef = useRef([]);
  const lastUpdateTimeRef = useRef(0);
  const iosAnimationRef = useRef(null);
  const retryCountRef = useRef(0);
  const retryTimeoutRef = useRef(null);
  const preloadAudioRef = useRef(null); // Stream preload için
  const [remainingTime, setRemainingTime] = useState(null); // Kalan süre (saniye)

  // 7.7 saniye = 7700ms, her 100ms'de bir güncelleme = 77 çubuk
  const BAR_COUNT = 77;
  const UPDATE_INTERVAL = 50; // ms

  // Süreyi formatla (saniye -> mm:ss)
  const formatDuration = useCallback((seconds) => {
    if (seconds === null || seconds === undefined) return '--:--';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }, []);

  // Sunucu saati ile cihaz saati arasındaki fark (ms). Telefon saati yanlış olsa bile süre doğru çıkar.
  const clockOffsetRef = useRef(0);
  const lastStateServerTimeRef = useRef(0);
  const refreshStateRef = useRef(null); // Durumu sunucudan yeniden çeken fonksiyon (socket effect'inde atanır)
  const lastEndRefreshRef = useRef(0);

  // Gelen yayın durumunu uygula (eski/geç gelen yanıtlar yeni durumu ezmesin)
  const applyRadioState = useCallback((state) => {
    if (!state) return;
    if (state.serverTime) {
      if (state.serverTime < lastStateServerTimeRef.current) return;
      lastStateServerTimeRef.current = state.serverTime;
      clockOffsetRef.current = state.serverTime - Date.now();
    }
    setRadioState(state);
  }, []);

  // Kalan süre hesaplama ve geri sayım
  useEffect(() => {
    if (!radioState.isPlaying || !radioState.trackStartTime || !radioState.currentTrack?.duration) {
      setRemainingTime(null);
      return;
    }

    const calculateRemaining = () => {
      const serverNow = Date.now() + clockOffsetRef.current;
      let elapsed = (serverNow - radioState.trackStartTime) / 1000;

      // Dinleyici yayını tampon kadar geriden duyar; bu gecikmeyi düş
      const audio = audioRef.current;
      if (audio && !audio.paused && audio.buffered && audio.buffered.length > 0) {
        const lag = audio.buffered.end(audio.buffered.length - 1) - audio.currentTime;
        if (lag > 0 && lag < 30) elapsed -= lag;
      }

      const remaining = Math.max(0, Math.round(radioState.currentTrack.duration - elapsed));
      setRemainingTime(remaining);

      // Süre bitti ama yeni parça bilgisi gelmediyse sunucuya sor (en fazla 5 sn'de bir)
      if (remaining === 0 && Date.now() - lastEndRefreshRef.current > 5000) {
        lastEndRefreshRef.current = Date.now();
        refreshStateRef.current?.();
      }
    };

    calculateRemaining();
    const interval = setInterval(calculateRemaining, 1000);
    return () => clearInterval(interval);
  }, [radioState.isPlaying, radioState.trackStartTime, radioState.currentTrack?.duration]);

  // Besmele'yi arka planda sessizce yükle (non-blocking)
  const preloadBesmele = useCallback(() => {
    // Hemen besmeleRef'i kullanılabilir yap, arka planda tam yüklensin
    if (besmeleRef.current) {
      besmeleRef.current.load();
      besmeleRef.current.oncanplaythrough = () => {
        besmeleReadyRef.current = true;
      };
    }
    // Arka planda fetch ile de önbelleğe al (browser cache için)
    fetch(BESMELE_URL).then(() => {
      besmeleReadyRef.current = true;
    }).catch(() => {});
  }, []);

  // Stream'i arka planda önceden buffer'la
  const preloadStream = useCallback(() => {
    if (preloadAudioRef.current) return;

    try {
      preloadAudioRef.current = new Audio();
      preloadAudioRef.current.preload = 'auto';
      preloadAudioRef.current.src = STREAM_URL;
      preloadAudioRef.current.volume = 0;
      preloadAudioRef.current.muted = true;

      preloadAudioRef.current.oncanplaythrough = () => {
        streamPreloadedRef.current = true;
      };

      preloadAudioRef.current.onerror = () => {
        preloadAudioRef.current = null;
      };

      preloadAudioRef.current.load();
    } catch (err) {}
  }, []);

  // Tarayıcı title'ını güncelle (araba ekranı vb. için)
  useEffect(() => {
    if (radioState.isPlaying && radioState.currentTrack?.name) {
      const trackName = radioState.currentTrack.name;
      const readerName = radioState.currentTrack.reader;
      if (readerName) {
        document.title = `Risale-i Nur Radyo | ${trackName} - ${readerName}`;
      } else {
        document.title = `Risale-i Nur Radyo - ${trackName}`;
      }
    } else {
      document.title = 'Risale-i Nur Radyo';
    }
  }, [radioState.isPlaying, radioState.currentTrack]);

  useEffect(() => {
    // Socket bağlantısını component mount olduğunda oluştur
    // Otomatik yeniden bağlanma ayarları ile
    socketRef.current = io(BASE_URL, {
      reconnection: true,
      reconnectionAttempts: Infinity, // Sınırsız deneme
      reconnectionDelay: 1000, // 1 saniye başlangıç
      reconnectionDelayMax: 10000, // Maksimum 10 saniye
      randomizationFactor: 0.5, // Gecikme rastgeleleştirme
      timeout: 20000, // Bağlantı zaman aşımı
      // Önce websocket dene (CORS'tan etkilenmez, bazı telefonlarda polling takılıyordu), olmazsa polling
      transports: ['websocket', 'polling'],
    });

    // Durumu REST üzerinden yeniden çek (socket koptuğunda / uygulama öne geldiğinde yedek)
    let refreshInFlight = false;
    const refreshState = () => {
      if (refreshInFlight) return;
      refreshInFlight = true;
      axios.get(`${API_URL}/radio/state`, { params: { t: Date.now() } })
        .then(res => applyRadioState(res.data))
        .catch(() => {})
        .finally(() => { refreshInFlight = false; });
    };
    refreshStateRef.current = refreshState;

    // Socket bağlantı olaylarını dinle
    socketRef.current.on('connect', () => {
      console.log('Socket bağlandı');
      // Bağlantı yeniden kurulduğunda state'i güncelle
      refreshState();
    });

    socketRef.current.on('disconnect', (reason) => {
      console.log('Socket bağlantısı kesildi:', reason);
      // Sunucu tarafından kesildiyse otomatik yeniden bağlanmaz, elle bağlan
      if (reason === 'io server disconnect' && socketRef.current) {
        socketRef.current.connect();
      }
    });

    // Telefon kilitten açıldığında / uygulamaya dönüldüğünde / internet geri geldiğinde güncelle
    const handleWakeUp = () => {
      if (document.visibilityState === 'hidden') return;
      refreshState();
      if (socketRef.current && !socketRef.current.connected) {
        socketRef.current.connect();
      }
    };
    document.addEventListener('visibilitychange', handleWakeUp);
    window.addEventListener('focus', handleWakeUp);
    window.addEventListener('online', handleWakeUp);
    window.addEventListener('pageshow', handleWakeUp);

    // Yedek kontrol: socket bağlı değilse 10 sn'de, bağlıysa 60 sn'de bir durumu çek
    let lastPoll = Date.now();
    const pollInterval = setInterval(() => {
      if (document.visibilityState === 'hidden') return;
      const connected = socketRef.current?.connected;
      if (!connected || Date.now() - lastPoll >= 60000) {
        lastPoll = Date.now();
        refreshState();
      }
    }, 10000);

    // Fetch initial state
    const fetchState = async () => {
      try {
        const res = await axios.get(`${API_URL}/radio/state`);
        applyRadioState(res.data);

        // Radyo açıksa stream'i önceden yükle
        if (res.data.isPlaying) {
          preloadStream();
        }
      } catch (err) {
        console.error('State alınamadı:', err);
      }
    };
    fetchState();

    // Bağlantıları yükle
    const fetchLinks = async () => {
      try {
        const res = await axios.get(`${API_URL}/links`);
        setLinks(res.data);
      } catch (err) {
        console.error('Bağlantılar alınamadı:', err);
      }
    };
    fetchLinks();

    // Okuyanları yükle
    const fetchReaders = async () => {
      try {
        const res = await axios.get(`${API_URL}/readers`);
        setReaders(res.data);
      } catch (err) {
        console.error('Okuyanlar alınamadı:', err);
      }
    };
    fetchReaders();

    // Hakkında metnini yükle
    const fetchAbout = async () => {
      try {
        const res = await axios.get(`${API_URL}/about`);
        setAboutText(res.data.text || '');
      } catch (err) {
        console.error('Hakkında alınamadı:', err);
      }
    };
    fetchAbout();

    // Slayt resimlerini yükle
    const fetchSlides = async () => {
      try {
        const res = await axios.get(`${API_URL}/slides`);
        setSlides(res.data);
      } catch (err) {
        console.error('Slaytlar alınamadı:', err);
      }
    };
    fetchSlides();

    // Besmele'yi hemen önbelleğe al
    preloadBesmele();

    // Listen for state updates
    socketRef.current.on('radio-state', (state) => {
      applyRadioState(state);
      // Radyo açıldığında stream'i önceden yükle
      if (state.isPlaying && !streamPreloadedRef.current) {
        preloadStream();
      }
    });

    // Cleanup: component unmount olduğunda socket ve audio bağlantısını kapat
    return () => {
      document.removeEventListener('visibilitychange', handleWakeUp);
      window.removeEventListener('focus', handleWakeUp);
      window.removeEventListener('online', handleWakeUp);
      window.removeEventListener('pageshow', handleWakeUp);
      clearInterval(pollInterval);
      refreshStateRef.current = null;
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current.load();
      }
      if (preloadAudioRef.current) {
        preloadAudioRef.current.pause();
        preloadAudioRef.current.src = '';
        preloadAudioRef.current = null;
      }
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, [preloadBesmele, preloadStream, applyRadioState]);
  useEffect(() => {
    const interval = setInterval(() => {
      setFakeListeners(getListenerCount());
    }, 120000);
    return () => clearInterval(interval);
  }, []);
  // Audio Waveform güncelleme fonksiyonu - sağdan sola doluyor
  const updateVisualizer = useCallback(() => {
    if (!analyserRef.current) return;

    const now = Date.now();

    // Her UPDATE_INTERVAL ms'de bir yeni çubuk ekle
    if (now - lastUpdateTimeRef.current >= UPDATE_INTERVAL) {
      const bufferLength = analyserRef.current.fftSize;
      const dataArray = new Uint8Array(bufferLength);
      // Time domain data kullan - gerçek ses dalgası için
      analyserRef.current.getByteTimeDomainData(dataArray);

      // RMS (Root Mean Square) hesapla - ses seviyesi için en doğru yöntem
      let sumSquares = 0;
      for (let i = 0; i < bufferLength; i++) {
        const normalized = (dataArray[i] - 128) / 128; // -1 ile 1 arasında
        sumSquares += normalized * normalized;
      }
      const rms = Math.sqrt(sumSquares / bufferLength);

      // RMS değerini yüksekliğe çevir
      let height;
      if (rms < 0.005) {
        height = 5; // Sessizlik - minimum görünür
      } else {
        const logScale = Math.log10(rms * 100 + 1) / Math.log10(101);
        height = 5 + logScale * 95;
      }

      // Yeni değeri sağdan ekle (sona ekle)
      waveformHistoryRef.current.push(height);

      // Maksimum BAR_COUNT kadar tut
      if (waveformHistoryRef.current.length > BAR_COUNT) {
        waveformHistoryRef.current.shift();
      }

      // Barları sağdan sola doldurmak için: önce minimum değerlerle başla, sonra gerçek değerler gelsin
      const filledBars = [];
      const emptyCount = BAR_COUNT - waveformHistoryRef.current.length;

      // Sol tarafta boş (minimum) barlar
      for (let i = 0; i < emptyCount; i++) {
        filledBars.push(5);
      }

      // Sağ tarafta gerçek değerler
      filledBars.push(...waveformHistoryRef.current);

      setWaveformBars(filledBars);
      lastUpdateTimeRef.current = now;
    }

    animationRef.current = requestAnimationFrame(updateVisualizer);
  }, []);

  // Audio Context ve Analyser kurulumu - Besmele + Stream birlikte
  const setupAudioContext = useCallback(() => {
    if (audioContextRef.current) return;

    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      audioContextRef.current = new AudioContext();

      // Analyser oluştur
      analyserRef.current = audioContextRef.current.createAnalyser();
      analyserRef.current.fftSize = 2048;
      analyserRef.current.smoothingTimeConstant = 0.3;

      // Mixer (GainNode) oluştur - iki kaynağı birleştirmek için
      mixerRef.current = audioContextRef.current.createGain();
      mixerRef.current.gain.value = 1;
      mixerRef.current.connect(analyserRef.current);
      analyserRef.current.connect(audioContextRef.current.destination);

      // Besmele kaynağını bağla
      if (besmeleRef.current && !besmeleSourceRef.current) {
        besmeleSourceRef.current = audioContextRef.current.createMediaElementSource(besmeleRef.current);
        besmeleSourceRef.current.connect(mixerRef.current);
      }

      // Stream kaynağını bağla
      if (audioRef.current && !sourceRef.current) {
        sourceRef.current = audioContextRef.current.createMediaElementSource(audioRef.current);
        sourceRef.current.connect(mixerRef.current);
      }

      updateVisualizer();
    } catch (err) {
      console.error('Audio context kurulum hatası:', err);
    }
  }, [updateVisualizer]);

  // iOS için simüle edilmiş animasyon
  const startIOSAnimation = useCallback(() => {
    if (iosAnimationRef.current) return;

    const animate = () => {
      const now = Date.now();
      if (now - lastUpdateTimeRef.current >= UPDATE_INTERVAL) {
        // Rastgele ama doğal görünen dalga
        const baseHeight = 30 + Math.sin(now / 500) * 15;
        const randomFactor = Math.random() * 25;
        const height = Math.min(95, Math.max(10, baseHeight + randomFactor));

        waveformHistoryRef.current.push(height);
        if (waveformHistoryRef.current.length > BAR_COUNT) {
          waveformHistoryRef.current.shift();
        }

        const filledBars = [];
        const emptyCount = BAR_COUNT - waveformHistoryRef.current.length;
        for (let i = 0; i < emptyCount; i++) {
          filledBars.push(5);
        }
        filledBars.push(...waveformHistoryRef.current);
        setWaveformBars(filledBars);
        lastUpdateTimeRef.current = now;
      }
      iosAnimationRef.current = requestAnimationFrame(animate);
    };
    animate();
  }, []);

  const stopIOSAnimation = useCallback(() => {
    if (iosAnimationRef.current) {
      cancelAnimationFrame(iosAnimationRef.current);
      iosAnimationRef.current = null;
    }
  }, []);

  const stopVisualizer = useCallback(() => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
    }
    stopIOSAnimation();
    waveformHistoryRef.current = [];
    lastUpdateTimeRef.current = 0;
    setWaveformBars(Array(77).fill(5));
  }, [stopIOSAnimation]);

  // Otomatik yeniden bağlanma fonksiyonu (sessiz, arka planda)
  const reconnectStream = useCallback(() => {
    if (!audioRef.current || !isPlaying) return;

    const maxRetries = 33;
    const baseDelay = 500; // 500ms başlangıç - daha hızlı

    if (retryCountRef.current >= maxRetries) {
      retryCountRef.current = 0;
      return;
    }

    retryCountRef.current++;
    const delay = Math.min(baseDelay * Math.pow(1.5, retryCountRef.current - 1), 5000); // Max 5 saniye

    retryTimeoutRef.current = setTimeout(() => {
      if (audioRef.current && isPlaying) {
        audioRef.current.src = STREAM_URL + '?t=' + Date.now();
        audioRef.current.load();
        audioRef.current.oncanplay = () => {
          audioRef.current.play()
            .then(() => {
              retryCountRef.current = 0;
            })
            .catch(() => {
              reconnectStream();
            });
          audioRef.current.oncanplay = null;
        };
      }
    }, delay);
  }, [isPlaying]);

  // Audio event handler'ları kurulumu (sessiz çalışır)
  const setupAudioEventHandlers = useCallback(() => {
    if (!audioRef.current) return;

    // Buffering timeout referansı
    let waitingTimeout = null;

    // Hata durumunda sessizce yeniden bağlan
    audioRef.current.onerror = () => {
      if (isPlaying) {
        reconnectStream();
      }
    };

    // Bağlantı kesildiğinde sessizce yeniden bağlan
    audioRef.current.onstalled = () => {
      if (isPlaying) {
        reconnectStream();
      }
    };

    // Buffering beklerken (5 saniyeden fazla beklerse yeniden bağlan)
    audioRef.current.onwaiting = () => {
      if (waitingTimeout) clearTimeout(waitingTimeout);
      waitingTimeout = setTimeout(() => {
        if (isPlaying) {
          reconnectStream();
        }
      }, 5000);
    };

    // Buffering bittiğinde
    audioRef.current.onplaying = () => {
      if (waitingTimeout) {
        clearTimeout(waitingTimeout);
        waitingTimeout = null;
      }
      retryCountRef.current = 0;
    };

    // Stream sona erdiğinde
    audioRef.current.onended = () => {
      if (isPlaying && radioState.isPlaying) {
        reconnectStream();
      }
    };
  }, [isPlaying, radioState.isPlaying, reconnectStream]);

  // Event handler'ları ayarla
  useEffect(() => {
    setupAudioEventHandlers();
  }, [setupAudioEventHandlers]);

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.src = '';
      audioRef.current.load();
    }
    if (retryTimeoutRef.current) {
      clearTimeout(retryTimeoutRef.current);
      retryTimeoutRef.current = null;
    }
    retryCountRef.current = 0;
    stopVisualizer();
  };

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      stopAudio();
      setSleepEndAt(null); // Elle durdurulunca zamanlayıcı iptal
      if (besmeleRef.current) {
        besmeleRef.current.pause();
        besmeleRef.current.currentTime = 0;
      }
      setIsPlaying(false);
      setIsStreamPlaying(false);
    } else {
      // iOS için farklı yaklaşım
      if (isIOS) {
        // iOS'te simüle animasyon başlat
        startIOSAnimation();

        // Besmele çal
        if (besmeleRef.current) {
          besmeleRef.current.currentTime = 0;
          besmeleRef.current.play().catch(() => {});
        }

        // iOS'te src ayarla, load() çağır ve canplay bekle
        audioRef.current.src = STREAM_URL;
        audioRef.current.load();
        audioRef.current.oncanplay = () => {
          audioRef.current.play()
            .then(() => {
              setIsStreamPlaying(true);
            })
            .catch(() => {
              reconnectStream();
            });
          audioRef.current.oncanplay = null;
        };
      } else {
        // Diğer platformlar için normal akış
        setupAudioContext();
        if (audioContextRef.current?.state === 'suspended') {
          audioContextRef.current.resume();
        }

        // Besmele çal - grafiğe yansıyacak
        if (besmeleRef.current) {
          besmeleRef.current.volume = volume;
          besmeleRef.current.currentTime = 0;
          besmeleRef.current.play().catch(() => {});
        }

        // Visualizer'ı başlat
        if (analyserRef.current && !animationRef.current) {
          updateVisualizer();
        }

        // Stream'i başlat - preload varsa kullan
        if (preloadAudioRef.current && streamPreloadedRef.current) {
          audioRef.current.src = preloadAudioRef.current.src;
        } else {
          audioRef.current.src = STREAM_URL;
        }

        audioRef.current.volume = volume;
        audioRef.current.load();

        // Hemen çalmaya başla - beklemeden
        audioRef.current.oncanplay = () => {
          audioRef.current.play()
            .then(() => {
              setIsStreamPlaying(true);
            })
            .catch(() => {
              reconnectStream();
            });
          audioRef.current.oncanplay = null;
        };
      }

      setIsPlaying(true);
    }
  };

  // ============ UYKU ZAMANLAYICISI ============
  // Süre bitince sesi yavaşça kısıp radyoyu durdurur (her render'da güncel togglePlay'i yakalar)
  sleepStopRef.current = () => {
    if (!isPlaying) return;
    const audio = audioRef.current;
    if (isIOS || !audio) {
      togglePlay();
      return;
    }
    const startVolume = audio.volume;
    const steps = 20;
    let step = 0;
    const fade = setInterval(() => {
      step++;
      if (audioRef.current) audioRef.current.volume = Math.max(0, startVolume * (1 - step / steps));
      if (step >= steps) {
        clearInterval(fade);
        togglePlay(); // Tekrar başlatıldığında ses seviyesi yeniden ayarlanır
      }
    }, 250); // ~5 saniyede sesi kıs
  };

  useEffect(() => {
    if (!sleepEndAt) return;
    const tick = () => {
      const left = sleepEndAt - Date.now();
      if (left <= 0) {
        setSleepEndAt(null);
        setSleepRemaining(0);
        sleepStopRef.current?.();
      } else {
        setSleepRemaining(Math.ceil(left / 1000));
      }
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [sleepEndAt]);

  const startSleepTimer = (minutes) => {
    if (!minutes || minutes <= 0) return;
    setSleepEndAt(Date.now() + minutes * 60 * 1000);
    setSleepRemaining(minutes * 60);
    setShowCustomTimer(false);
    // Radyo çalmıyorsa başlat (yayın açıksa)
    if (!isPlaying && radioState.isPlaying) togglePlay();
  };

  const cancelSleepTimer = () => {
    setSleepEndAt(null);
    setSleepRemaining(0);
  };

  // Özel süre: toplam dakika olarak tutulur (5 dk – 23 sa 55 dk)
  const MIN_CUSTOM_MINUTES = 5;
  const MAX_CUSTOM_MINUTES = 23 * 60 + 55;
  const adjustCustomTime = (deltaMinutes) =>
    setCustomTotalMinutes(t => Math.min(MAX_CUSTOM_MINUTES, Math.max(MIN_CUSTOM_MINUTES, t + deltaMinutes)));
  const customHours = Math.floor(customTotalMinutes / 60);
  const customMinutes = customTotalMinutes % 60;

  const formatSleepTime = (totalSeconds) => {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    const mm = String(m).padStart(2, '0');
    const ss = String(s).padStart(2, '0');
    return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
  };

  const formatClock = (timestamp) =>
    new Date(timestamp).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });

  const openMenuView = (view) => {
    setModalView(view);
    setShowLinksModal(true);
  };

  const closeMenu = () => {
    setShowLinksModal(false);
    setModalView('main');
    setShowCustomTimer(false);
  };

  // Fisher-Yates shuffle algoritması
  const shuffleArray = useCallback((array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }, []);

  // Resim önbelleğe alma fonksiyonu
  const preloadImage = useCallback((index, slideList) => {
    if (!slideList || slideList.length === 0 || index < 0 || index >= slideList.length) return;

    const imageUrl = `${BASE_URL}/slides/${slideList[index].filename}`;

    // Zaten yüklenmişse tekrar yükleme
    if (preloadedImages[imageUrl]) return;

    const img = new Image();
    img.onload = () => {
      setPreloadedImages(prev => ({ ...prev, [imageUrl]: true }));
    };
    img.src = imageUrl;
  }, [preloadedImages]);

  // Tam ekran API fonksiyonları
  const enterFullscreen = useCallback((element) => {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }, []);

  const exitFullscreen = useCallback(() => {
    if (document.exitFullscreen) {
      document.exitFullscreen().catch(() => {});
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }, []);

  // Ekran kararmasını önleme (Wake Lock API)
  const requestWakeLock = useCallback(async () => {
    try {
      if ('wakeLock' in navigator) {
        wakeLockRef.current = await navigator.wakeLock.request('screen');
      }
    } catch (err) {
      // Wake Lock desteklenmiyor veya izin verilmedi
    }
  }, []);

  const releaseWakeLock = useCallback(() => {
    if (wakeLockRef.current) {
      wakeLockRef.current.release();
      wakeLockRef.current = null;
    }
  }, []);

  // Slayt gösterisi fonksiyonları
  const slideshowRef = useRef(null);

  const startSlideshow = useCallback(() => {
    if (slides.length === 0) return;

    // Slaytları karıştır
    const shuffled = shuffleArray(slides);
    setShuffledSlides(shuffled);

    setShowSlideshow(true);
    setCurrentSlideIndex(0);
    setSlideTransition(false);

    // Ekran kararmasını önle
    requestWakeLock();

    // Tam ekran moduna geç (küçük gecikme ile DOM güncellemesi beklensin)
    setTimeout(() => {
      if (slideshowRef.current) {
        enterFullscreen(slideshowRef.current);
      }
    }, 100);

    // İlk ve ikinci resmi hemen yükle
    preloadImage(0, shuffled);
    preloadImage(1, shuffled);

    // 30 saniyede bir resim değiştir
    slideshowIntervalRef.current = setInterval(() => {
      // Önce fade-out başlat
      setSlideTransition(true);

      // 500ms sonra resmi değiştir ve fade-in yap
      setTimeout(() => {
        setCurrentSlideIndex(prev => {
          const newIndex = (prev + 1) % shuffled.length;
          // Bir sonraki resmi önceden yükle (25 sn sonra değil, hemen)
          preloadImage((newIndex + 1) % shuffled.length, shuffled);
          return newIndex;
        });
        setSlideTransition(false);
      }, 500);
    }, 30000);

    // 25 sn sonra 2. resmi yükle
    preloadTimeoutRef.current = setTimeout(() => {
      preloadImage(1, shuffled);
    }, 25000);
  }, [slides, shuffleArray, preloadImage, enterFullscreen, requestWakeLock]);

  const stopSlideshow = useCallback(() => {
    setShowSlideshow(false);
    setSlideTransition(false);
    exitFullscreen();
    releaseWakeLock(); // Ekran kilidini serbest bırak
    if (slideshowIntervalRef.current) {
      clearInterval(slideshowIntervalRef.current);
      slideshowIntervalRef.current = null;
    }
    if (preloadTimeoutRef.current) {
      clearTimeout(preloadTimeoutRef.current);
      preloadTimeoutRef.current = null;
    }
  }, [exitFullscreen, releaseWakeLock]);

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    setPrevVolume(newVolume);
    if (audioRef.current) {
      audioRef.current.volume = newVolume;
    }
    if (besmeleRef.current) {
      besmeleRef.current.volume = newVolume;
    }
  };

  const toggleMute = () => {
    if (volume > 0) {
      setPrevVolume(volume);
      setVolume(0);
      if (audioRef.current) audioRef.current.volume = 0;
      if (besmeleRef.current) besmeleRef.current.volume = 0;
    } else {
      setVolume(prevVolume);
      if (audioRef.current) audioRef.current.volume = prevVolume;
      if (besmeleRef.current) besmeleRef.current.volume = prevVolume;
    }
  };

  return (
    <div className="listener-container">
      <div className="radio-player">
        <div className="radio-logo">
          <div className="radio-title">
            <h1 className="radio-title-main">RİSALE-İ NUR</h1>
            <h2 className="radio-title-sub">RADYO</h2>
          </div>
        </div>

        <div className="now-playing">
        
          {radioState.isPlaying && (
            <div></div>

          )}
        </div>

        <div className="player-controls">
          <button
            className={`play-button ${isPlaying ? 'playing' : ''}`}
            onClick={togglePlay}
            disabled={!radioState.isPlaying}
          >
            {isPlaying ? '❚❚' : '▶'}
          </button>

          {/* Okuyan Adı */}
          {radioState.currentTrack?.reader && (
            <div className="now-playing-reader">
              {radioState.currentTrack.reader}
            </div>
          )}

          {/* Kayan Açıklama */}
          {radioState.currentTrack?.description && (
            <div className="now-playing-description">
              <div className="marquee-wrapper">
                <span className="marquee-text">
                  {radioState.currentTrack.description}
                </span>
              </div>
            </div>
          )}

          <div className="audio-waveform">
            <div className="waveform-bars">
              {waveformBars.map((height, index) => (
                <div
                  key={index}
                  className="waveform-bar"
                  style={{ height: isPlaying ? `${height}%` : '4px' }}
                />
              ))}
            </div>
          </div>

          {/* Kalan Süre Gösterimi */}
          {radioState.isPlaying && remainingTime !== null && (
              <span className="remaining-countdown">{formatDuration(remainingTime)}</span>
          )}
        </div>

        {!radioState.isPlaying && (
          <p className="offline-message">Bismillah</p>
        )}

        {isIOS ? (
          <div className="volume-control ios-volume-hint">
            <span className="volume-icon">🔈</span>
            <span style={{ fontSize: '0.8rem', opacity: 0.7 }}>
              Ses: Cihaz tuşlarını kullanın
            </span>
          </div>
        ) : (
          <div className="volume-control">
            <span className="volume-icon" onClick={toggleMute}>
              {volume === 0 ? '🔇' : '🔈'}
            </span>
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
              value={volume}
              onChange={handleVolumeChange}
              style={{ background: `linear-gradient(to right,rgb(240, 12, 12) 0%,rgb(241, 12, 12) ${volume * 100}%, rgba(255,255,255,0.3) ${volume * 100}%, rgba(255,255,255,0.3) 100%)` }}
            />
          </div>
        )}

        <div className="listeners-count">
          {(radioState.listeners || 0)  + fakeListeners} dinleyici
        </div>

        {/* Aktif zamanlayıcı göstergesi */}
        {sleepEndAt && (
          <button className="sleep-timer-pill" onClick={() => openMenuView('timer')}>
            <span className="sleep-timer-pill-icon">⏳</span>
            {formatSleepTime(sleepRemaining)}
          </button>
        )}

        <audio ref={audioRef} crossOrigin={isIOS ? undefined : "anonymous"} playsInline />
        <audio ref={besmeleRef} src={BESMELE_URL} preload="auto" crossOrigin={isIOS ? undefined : "anonymous"} playsInline />
      </div>

      {/* Menü Butonu - Sağ Alt */}
      <button className="links-trigger" onClick={() => openMenuView('main')}>
        Menü
      </button>

      {/* Menü Modal */}
      {showLinksModal && (
        <div className="links-modal-overlay" onClick={closeMenu}>
          <div className="links-modal" onClick={(e) => e.stopPropagation()}>
            <button className="links-modal-close" onClick={closeMenu}>
              ✕
            </button>

            {/* Geri Butonu - Alt sayfalarda göster */}
            {modalView !== 'main' && (
              <button
                className="links-modal-back"
                onClick={() => {
                  if (modalView === 'timer' && showCustomTimer) setShowCustomTimer(false);
                  else setModalView('main');
                }}
              >
                ← Geri
              </button>
            )}

            {/* Başlık */}
            <div className="links-modal-header">
              <h3>
                {modalView === 'main' && 'Menü'}
                {modalView === 'readers' && 'Okuyanlar'}
                {modalView === 'about' && 'Hakkında'}
                {modalView === 'timer' && 'Zamanlayıcı'}
              </h3>
            </div>

            <div className="links-modal-content">
              {/* Ana Sayfa */}
              {modalView === 'main' && (() => {
                const featuredLinks = links.filter(getFeaturedType);
                const otherLinks = links.filter(link => !getFeaturedType(link));
                const renderLinkIcon = (link) => {
                  if (link.customIcon) {
                    return <img src={`${BASE_URL}/icons/${link.customIcon}`} alt={link.name} />;
                  }
                  if (getFeaturedType(link) === 'playstore') {
                    return <span dangerouslySetInnerHTML={{ __html: PLAY_STORE_SVG }} />;
                  }
                  const iconData = getIconById(link.iconId);
                  return iconData ? <span dangerouslySetInnerHTML={{ __html: iconData.svg }} /> : <span>🔗</span>;
                };

                return (
                <>
                  {/* Öne çıkan: Play Store ve YouTube */}
                  {featuredLinks.length > 0 && (
                    <div className={`menu-featured ${featuredLinks.length === 1 ? 'single' : ''}`}>
                      {featuredLinks.map(link => (
                        <a
                          key={link.id}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`menu-featured-item ${getFeaturedType(link)}`}
                        >
                          <span className="menu-featured-icon">{renderLinkIcon(link)}</span>
                          <span className="menu-featured-name">{link.name}</span>
                        </a>
                      ))}
                    </div>
                  )}

                  {/* Menü butonları - 2 sütun */}
                  <div className="menu-grid">
                    <button className="menu-tile" onClick={() => setModalView('timer')}>
                      <span className="menu-tile-icon">⏳</span>
                      <span className="menu-tile-title">Zamanlayıcı</span>
                      {sleepEndAt && (
                        <span className="menu-tile-badge">{formatSleepTime(sleepRemaining)}</span>
                      )}
                    </button>

                    {slides.length > 0 && (
                      <button
                        className="menu-tile"
                        onClick={() => {
                          closeMenu();
                          startSlideshow();
                        }}
                      >
                        <span className="menu-tile-icon">🖼️</span>
                        <span className="menu-tile-title">Resim Modu</span>
                      </button>
                    )}

                    <button className="menu-tile" onClick={() => setModalView('readers')}>
                      <span className="menu-tile-icon">📖</span>
                      <span className="menu-tile-title">Okuyanlar</span>
                    </button>

                    <button className="menu-tile" onClick={() => setModalView('about')}>
                      <span className="menu-tile-icon">ℹ️</span>
                      <span className="menu-tile-title">Hakkında</span>
                    </button>
                  </div>

                  {/* Diğer bağlantılar - küçük ikonlar */}
                  {otherLinks.length > 0 && (
                    <div className="menu-social">
                      {otherLinks.map(link => (
                        <a
                          key={link.id}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="menu-social-item"
                          title={link.name}
                        >
                          <span className="menu-social-icon">{renderLinkIcon(link)}</span>
                          <span className="menu-social-name">{link.name}</span>
                        </a>
                      ))}
                    </div>
                  )}
                </>
                );
              })()}

              {/* Okuyanlar Sayfası */}
              {modalView === 'readers' && (
                <div className="readers-list">
                  {readers.length > 0 ? (
                    readers.map(reader => (
                      <div key={reader.id} className="reader-item">
                        <div className="reader-icon">📖</div>
                        <span className="reader-name">{reader.name}</span>
                      </div>
                    ))
                  ) : (
                    <p className="links-modal-empty">Henüz okuyan eklenmemiş</p>
                  )}
                </div>
              )}

              {/* Zamanlayıcı Sayfası */}
              {modalView === 'timer' && (
                <div className="sleep-timer">
                  {sleepEndAt && !showCustomTimer ? (
                    <div className="sleep-timer-active">
                      <div className="sleep-timer-ring">
                        <span className="sleep-timer-countdown">{formatSleepTime(sleepRemaining)}</span>
                        <span className="sleep-timer-caption">kaldı</span>
                      </div>
                      <p className="sleep-timer-info">
                        Kapanış saati: <strong>{formatClock(sleepEndAt)}</strong>
                      </p>
                      <div className="sleep-timer-actions">
                        <button className="sleep-timer-secondary" onClick={() => setSleepEndAt(t => t + 15 * 60 * 1000)}>
                          +15 dk
                        </button>
                        <button className="sleep-timer-danger" onClick={cancelSleepTimer}>
                          İptal Et
                        </button>
                      </div>
                    </div>
                  ) : showCustomTimer ? (
                    <div className="sleep-timer-custom">
                      <div className="sleep-timer-picker">
                        <div className="sleep-timer-column">
                          <button className="sleep-timer-step" onClick={() => adjustCustomTime(60)} aria-label="Saat artır">▲</button>
                          <span className="sleep-timer-value">{String(customHours).padStart(2, '0')}</span>
                          <button className="sleep-timer-step" onClick={() => adjustCustomTime(-60)} aria-label="Saat azalt">▼</button>
                          <span className="sleep-timer-unit">saat</span>
                        </div>
                        <span className="sleep-timer-colon">:</span>
                        <div className="sleep-timer-column">
                          <button className="sleep-timer-step" onClick={() => adjustCustomTime(5)} aria-label="Dakika artır">▲</button>
                          <span className="sleep-timer-value">{String(customMinutes).padStart(2, '0')}</span>
                          <button className="sleep-timer-step" onClick={() => adjustCustomTime(-5)} aria-label="Dakika azalt">▼</button>
                          <span className="sleep-timer-unit">dakika</span>
                        </div>
                      </div>
                      <div className="sleep-timer-quick">
                        {[45, 60, 90, 180].map(m => (
                          <button
                            key={m}
                            className={`sleep-timer-chip ${customTotalMinutes === m ? 'active' : ''}`}
                            onClick={() => setCustomTotalMinutes(m)}
                          >
                            {m < 60 ? `${m} dk` : m % 60 === 0 ? `${m / 60} saat` : `${Math.floor(m / 60)},5 saat`}
                          </button>
                        ))}
                      </div>
                      <p className="sleep-timer-info">
                        Kapanış saati: <strong>{formatClock(Date.now() + customTotalMinutes * 60000)}</strong>
                      </p>
                      <button className="sleep-timer-primary" onClick={() => startSleepTimer(customTotalMinutes)}>
                        Başlat
                      </button>
                    </div>
                  ) : (
                    <>
                      <p className="sleep-timer-info" style={{ marginTop: 0 }}>
                        Seçtiğiniz süre boyunca radyo çalar, süre bitince ses yavaşça kısılarak durur.
                      </p>
                      <div className="sleep-timer-options">
                        {[
                          { label: '15', unit: 'dakika', minutes: 15 },
                          { label: '30', unit: 'dakika', minutes: 30 },
                          { label: '2', unit: 'saat', minutes: 120 }
                        ].map(opt => (
                          <button key={opt.minutes} className="sleep-timer-option" onClick={() => startSleepTimer(opt.minutes)}>
                            <span className="sleep-timer-option-value">{opt.label}</span>
                            <span className="sleep-timer-option-unit">{opt.unit}</span>
                          </button>
                        ))}
                        <button className="sleep-timer-option other" onClick={() => setShowCustomTimer(true)}>
                          <span className="sleep-timer-option-value">⋯</span>
                          <span className="sleep-timer-option-unit">Diğer</span>
                        </button>
                      </div>
                      {!radioState.isPlaying && (
                        <p className="sleep-timer-info" style={{ opacity: 0.6 }}>Yayın şu an kapalı.</p>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* Hakkında Sayfası */}
              {modalView === 'about' && (
                <div className="about-content">
                  {aboutText ? (
                    <p className="about-text">{aboutText}</p>
                  ) : (
                    <p className="links-modal-empty">Henüz hakkında bilgisi eklenmemiş</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Tam Ekran Slayt Gösterisi */}
      {showSlideshow && shuffledSlides.length > 0 && (
        <div ref={slideshowRef} className="slideshow-fullscreen" onClick={stopSlideshow}>
          <img
            key={currentSlideIndex}
            src={`${BASE_URL}/slides/${shuffledSlides[currentSlideIndex].filename}`}
            alt="Slayt"
            className={`slideshow-image ${slideTransition ? 'fade-out' : 'fade-in'}`}
          />
          <div className="slideshow-hint">Kapatmak için ekrana dokunun</div>
        </div>
      )}
    </div>
  );
}

export default Listener;
